import { ContactSummary } from '@jms/model';

// The api labels resources it didn't recommend with their own contact type, so a real recommendation group differs from the type.
const isRecommended = (item: ContactSummary) => !!item['group'] && item['group'] !== item.type;

/** Applies the api recommendation groups. Resources without one fall back to their contact type, or to no group at all when nothing was recommended. */
export function applyRecommendationGrouping(items: ContactSummary[], fallbackToType = false): ContactSummary[] {

  const recommended = items.some(isRecommended);

  return items.map(x => {

    if (isRecommended(x)) {
      return x;
    }

    x['group'] = fallbackToType
      ? x.type
      : recommended ? 'Employee(s)' : undefined;

    return x;
  });
}
